import { render, staticRenderFns } from "./MarketingPreferencesAttributesTable.vue?vue&type=template&id=51511d05&scoped=true&"
import script from "./MarketingPreferencesAttributesTable.vue?vue&type=script&lang=js&"
export * from "./MarketingPreferencesAttributesTable.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPreferencesAttributesTable.vue?vue&type=style&index=0&id=51511d05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51511d05",
  null
  
)

export default component.exports